import { observable, action } from 'mobx';

import { provideSingleton, inject } from '../utils/decorators';
import { IAuftrag } from '../models/ApiTypes';
import { ApiStore } from './ApiStore';

@provideSingleton(AuftragStore)
export class AuftragStore {

  @inject(ApiStore) apiStore: ApiStore;

  @observable auftrag?: IAuftrag = undefined;

  @action setAuftrag(auftrag: IAuftrag) {
    this.auftrag = auftrag;
  }

  @action clearAuftrag() {
    this.auftrag = undefined;
  }

  async loadAuftrag(auftragId: string) {
    this.clearAuftrag();
    const response = await this.apiStore.auftragDetails(auftragId);
    if (response.ok) {
      this.setAuftrag(response.json);
    }
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/stores/AuftragStore.ts